import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sm_access_token";

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || "";
    } catch {
        return "";
    }
}

export function setToken(token) {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        // ignore (private mode / storage disabled)
    }
}

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach Bearer token automatically (fallback for Safari iOS / ITP where
// third-party cookies are blocked when frontend and backend are on
// different registrable domains).
api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function fileUrl(path) {
    if (!path) return "";
    // Cloudinary or any absolute URL → return as-is
    if (/^https?:\/\//i.test(path)) return path;
    // Legacy: backend-served local file
    return `${API_BASE}/files/${path}`;
}

export function formatErr(detail) {
    if (detail == null) return "Une erreur est survenue.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
